import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const ReturnIcon: React.FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.33335 4H10.3334C11.9902 4 13.3334 5.34315 13.3334 7C13.3334 8.65687 11.9902 10 10.3334 10H2.66669"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66667 8C4.66667 8 2.66669 9.473 2.66669 10C2.66668 10.5271 4.66669 12 4.66669 12"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
